var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.39363 15.201C6.39363 15.201 4.49365 13.9941 2.19888 12.1413C1.70654 11.7437 0.98247 11.8335 0.602825 12.3392C0.32672 12.7069 0.304181 13.2056 0.545069 13.5968C1.70619 15.4838 3.71218 18.4597 5.26351 20.4146C5.99568 21.3373 7.2952 21.4225 8.14922 20.6118C13.0621 15.949 17.622 10.0666 23.0818 1.92154C23.3984 1.44927 23.2392 0.806905 22.7381 0.537843C22.3552 0.332526 21.8823 0.4093 21.584 0.724848C15.5269 7.1383 12.4204 10.1864 6.39363 15.2006V15.201Z",
    fill: "#38BB9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.6f72f677e86a176f9637fa159138a0ff.svg";
export { ForwardRef as ReactComponent };